/* GRENADINE – panier lateral identique a l'ancien theme (section gro-cart-drawer, id #drawer-cart).
   Ouverture / fermeture, rafraichissement apres chaque modification, quantite, suppression,
   ajout depuis "Recommande". Les aides de l'ancien theme (menu quantite, carrousel, accordeon,
   blocage du defilement) sont reprises telles quelles plus bas. */
(function () {
  if (window.__grDrawer) return;
  window.__grDrawer = true;
  var SID = 'gro-cart-drawer';
  function root() { return document.getElementById('drawer-cart'); }
  function open() {
    var d = root(); if (!d) return;
    d.classList.add('drawer--visible');
    document.documentElement.classList.add('gr-cart-open');
    var t = d.querySelector('.drawer__close'); if (t) t.setAttribute('aria-expanded', 'true');
    /* l'indication "Faites defiler" (script de la section) se recalcule une fois le panier ouvert */
    [60, 350, 800].forEach(function (ms) { setTimeout(function () { window.dispatchEvent(new Event('resize')); }, ms); });
  }
  function close() {
    var d = root(); if (!d) return;
    d.classList.remove('drawer--visible');
    document.documentElement.classList.remove('gr-cart-open');
  }
  var busy = null;
  function refresh(openAfter) {
    /* jamais de version en cache : sinon le panier affiche son ancien contenu apres un ajout */
    return fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + '?sections=' + SID + '&_=' + Date.now(), { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data && data[SID]; var cur = root(); if (!html || !cur) return;
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var fresh = tmp.querySelector('#drawer-cart'); if (!fresh) return;
        var wasOpen = cur.classList.contains('drawer--visible');
        var track = cur.querySelector('[data-upsell-carousel-track]'), sl = track ? track.scrollLeft : 0;
        cur.innerHTML = fresh.innerHTML;
        var nt = cur.querySelector('[data-upsell-carousel-track]'); if (nt) nt.scrollLeft = sl;
        if (wasOpen || openAfter) open();
        unshimmer(cur);
      }).catch(function () {});
  }
  window.grOpenCart = open; window.grCloseCart = close; window.grRefreshCart = refresh;

  /* images : l'ancien theme retirait l'effet de chargement (loading-shimmer) une fois l'image chargee */
  function unshimmer(scope) {
    (scope || document).querySelectorAll('#drawer-cart .loading-shimmer img, .qty-dropdown__list .loading-shimmer img').forEach(function (img) {
      var box = img.closest('.loading-shimmer');
      var done = function () { if (box) box.classList.remove('loading-shimmer'); };
      if (img.complete && img.naturalWidth) done(); else { img.addEventListener('load', done, { once: true }); img.addEventListener('error', done, { once: true }); }
    });
  }
  document.addEventListener('DOMContentLoaded', function () { unshimmer(); });
  new MutationObserver(function () { unshimmer(); }).observe(document.documentElement, { childList: true, subtree: true });

  function changeLine(key, qty, row) {
    if (row) { var lb = row.querySelector('[data-item-loadbar]'); if (lb) lb.style.display = 'block'; }
    return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) });
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-drawer-toggle="drawer-cart"]');
    if (t) {
      e.preventDefault(); e.stopPropagation();
      var d = root(); if (d && d.classList.contains('drawer--visible')) close(); else open();
      return;
    }
    if (e.target.closest && e.target.closest('[data-drawer-underlay]')) { close(); return; }
    var rm = e.target.closest && e.target.closest('a[data-remove-key]');
    if (rm) { e.preventDefault(); changeLine(rm.getAttribute('data-remove-key'), 0, rm.closest('[data-cart-item]')); return; }
    var up = e.target.closest && e.target.closest('[data-cart-upsell-add]');
    if (up) {
      e.preventDefault(); up.classList.add('loading'); up.disabled = true;
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +up.getAttribute('data-variant-id'), quantity: 1 }] }) })
        .finally(function () { up.classList.remove('loading'); up.disabled = false; });
    }
  }, true);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  /* quantite (menu deroulant de l'ancien theme -> champ cache -> evenement change non propage) */
  document.addEventListener('change', function (e) {
    var inp = e.target.closest && e.target.closest('#drawer-cart [data-update-cart]');
    if (!inp) return;
    changeLine(inp.getAttribute('data-update-cart'), Math.max(0, parseInt(inp.value, 10) || 0), inp.closest('[data-cart-item]'));
  }, true);
})();

/* ===== aides reprises de l'ancien theme (assets/gr-layout-2.js) ===== */
;
    (function () {
      if (window.__grenadineQtyDropdownInstalled) { return; }
      window.__grenadineQtyDropdownInstalled = true;

      function returnListHome(list) {
        var home = list.__qtyPortalHome;
        if (!home) { return; }
        if (home.next && home.next.parentNode === home.parent) {
          home.parent.insertBefore(list, home.next);
        } else {
          home.parent.appendChild(list);
        }
        list.style.position = '';
        list.style.top = '';
        list.style.left = '';
        list.style.right = '';
        list.style.minWidth = '';
        list.style.zIndex = '';
        list.__qtyPortalHome = null;
      }

      function closeAllDropdowns(except) {
        var lists = document.querySelectorAll('[data-qty-dropdown-list]');
        for (var i = 0; i < lists.length; i++) {
          if (lists[i] !== except) {
            lists[i].hidden = true;
            returnListHome(lists[i]);
            var dropdown = lists[i].closest('[data-qty-dropdown]');
            var toggle = dropdown ? dropdown.querySelector('[data-qty-dropdown-toggle]') : null;
            if (toggle) { toggle.setAttribute('aria-expanded', 'false'); }
          }
        }
      }

      function openListAsPortal(list, toggle) {
        list.__qtyPortalHome = { parent: list.parentNode, next: list.nextSibling };
        list.__qtyWrapper = toggle.closest('[data-quantity-selector]');
        var rect = toggle.getBoundingClientRect();
        document.body.appendChild(list);
        list.style.position = 'fixed';
        list.style.top = (rect.bottom + 4) + 'px';
        list.style.minWidth = rect.width + 'px';
        list.style.zIndex = '99999';
        var approxWidth = Math.max(rect.width, 80);
        if (rect.left + approxWidth > window.innerWidth) {
          list.style.left = '';
          list.style.right = (window.innerWidth - rect.right) + 'px';
        } else {
          list.style.right = '';
          list.style.left = rect.left + 'px';
        }
      }

      document.addEventListener('click', function (e) {
        var toggle = e.target.closest('[data-qty-dropdown-toggle]');
        if (toggle) {
          e.preventDefault();
          var dropdown = toggle.closest('[data-qty-dropdown]');
          var list = dropdown ? dropdown.querySelector('[data-qty-dropdown-list]') : null;
          if (!list) { return; }
          var wasOpen = !list.hidden;
          closeAllDropdowns();
          list.hidden = wasOpen;
          toggle.setAttribute('aria-expanded', String(!wasOpen));
          if (!wasOpen) {
            openListAsPortal(list, toggle);
          }
          return;
        }

        var option = e.target.closest('[data-qty-dropdown-option]');
        if (option) {
          e.preventDefault();
          var optionList = option.closest('[data-qty-dropdown-list]');
          var wrapper = (optionList && optionList.__qtyWrapper) || option.closest('[data-quantity-selector]');
          if (!wrapper) { return; }
          var value = option.getAttribute('data-qty-dropdown-option');
          var input = wrapper.querySelector('[data-quantity-input]');
          var display = wrapper.querySelector('[data-qty-dropdown-value]');
          if (input) {
            input.value = value;
            input.dispatchEvent(new Event('change'));
          }
          if (display) { display.textContent = value; }
          var siblingOptions = wrapper.querySelectorAll('[data-qty-dropdown-option]');
          for (var j = 0; j < siblingOptions.length; j++) {
            siblingOptions[j].classList.toggle('is-selected', siblingOptions[j] === option);
          }
          closeAllDropdowns();
          return;
        }

        if (!e.target.closest('[data-qty-dropdown]')) {
          closeAllDropdowns();
        }
      });
    })();
  
;
    (function () {
      if (window.__grenadineUpsellCarouselInstalled) { return; }
      window.__grenadineUpsellCarouselInstalled = true;

      function scrollTrack(track, direction) {
        var firstCard = track.querySelector(':scope > *');
        var cardWidth = firstCard ? firstCard.getBoundingClientRect().width : 190;
        var gap = 12;
        track.scrollBy({ left: direction * (cardWidth + gap), behavior: 'auto' });
      }

      document.addEventListener('click', function (e) {
        var prevBtn = e.target.closest('[data-upsell-carousel-prev]');
        var nextBtn = e.target.closest('[data-upsell-carousel-next]');
        if (!prevBtn && !nextBtn) { return; }
        e.preventDefault();
        var holder = (prevBtn || nextBtn).closest('.upsell__holder');
        var track = holder ? holder.querySelector('[data-upsell-carousel-track]') : null;
        if (!track) { return; }
        scrollTrack(track, prevBtn ? -1 : 1);
      });
    })();
  
;
    (function () {
      if (window.__grenadinePaymentAccordionFixInstalled) { return; }
      window.__grenadinePaymentAccordionFixInstalled = true;

      var ACCORDION_TRIGGER_SELECTOR = '[data-upsell-refresh] [data-accordion-trigger], [data-payment-accordion-refresh] [data-accordion-trigger]';

      function toggleGrenadineAccordion(trigger) {
        var targetId = trigger.getAttribute('aria-controls') || trigger.getAttribute('data-accordion-trigger');
        var body = targetId ? document.getElementById(targetId) : null;
        if (!body) { return; }

        var isOpen = trigger.getAttribute('aria-expanded') === 'true';
        var nextOpen = !isOpen;

        trigger.setAttribute('aria-expanded', String(nextOpen));
        body.style.display = nextOpen ? 'block' : 'none';
      }

      document.addEventListener('touchend', function (e) {
        var trigger = e.target.closest(ACCORDION_TRIGGER_SELECTOR);
        if (!trigger) { return; }

        e.preventDefault();
        e.stopPropagation();

        trigger.__grenadineTouchToggledAt = Date.now();
        toggleGrenadineAccordion(trigger);
      }, { capture: true, passive: false });

      document.addEventListener('click', function (e) {
        var trigger = e.target.closest(ACCORDION_TRIGGER_SELECTOR);
        if (!trigger) { return; }

        e.preventDefault();
        e.stopPropagation();

        var recentlyToggledByTouch = trigger.__grenadineTouchToggledAt &&
          (Date.now() - trigger.__grenadineTouchToggledAt) < 800;
        if (recentlyToggledByTouch) { return; }

        toggleGrenadineAccordion(trigger);
      }, true);
    })();
  
;
    (function () {
      if (window.__grenadineCartScrollLockInstalled) { return; }
      window.__grenadineCartScrollLockInstalled = true;

      function isCartDrawerOpen() {
        var drawer = document.getElementById('drawer-cart');
        return !!(drawer && drawer.classList.contains('drawer--visible'));
      }

      function blockIfOutsideDrawer(e) {
        if (!isCartDrawerOpen()) { return; }
        var target = e.target;
        if (target && target.closest && target.closest('#drawer-cart')) { return; }
        if (target && target.closest && target.closest('[data-qty-dropdown-list]')) { return; }
        e.preventDefault();
      }

      document.addEventListener('wheel', blockIfOutsideDrawer, { passive: false });
      document.addEventListener('touchmove', blockIfOutsideDrawer, { passive: false });

      document.addEventListener('touchmove', function (e) {
        var target = e.target;
        if (target && target.closest && target.closest('[data-upsell-carousel-track]')) {
          e.stopPropagation();
        }
      }, { capture: true, passive: true });

      function startWatching() {
        var drawer = document.getElementById('drawer-cart');
        if (!drawer) { return; }
        var observer = new MutationObserver(function () {
          if (drawer.classList.contains('drawer--visible')) {
            document.body.style.overflow = 'hidden';
            document.documentElement.style.overflow = 'hidden';
          } else {
            document.body.style.overflow = '';
            document.documentElement.style.overflow = '';
          }
        });
        observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });
      }

      if (document.getElementById('drawer-cart')) {
        startWatching();
      } else {
        document.addEventListener('DOMContentLoaded', startWatching);
      }
    })();
